export const LOADING = "LOADING";
export const LOAD_USER_PROFILE = "LOAD_USER_PROFILE";
export const UPDATE_DISPLAY_PRESENCE = "UPDATE_DISPLAY_PRESENCE";
export const PERFORM_LOGOUT = "PERFORM_LOGOUT";
export const SET_REQUEST_DEVICE = "SET_REQUEST_DEVICE";
export const SET_PUBLIC_TEMPLATE = "SET_PUBLIC_TEMPLATE";

export const ACCOUNT_FORM_FIELD_CHANGE = "ACCOUNT_FORM_FIELD_CHANGE";
export const STATS_UPDATED = "STATS_UPDATED";

export const ACCOUNT_UPDATE_DURING = "ACCOUNT_UPDATE_DURING";
export const ACCOUNT_UPDATE_ALERT = "ACCOUNT_UPDATE_ALERT";
export const ACCOUNT_UPDATE_ALERT_SNOOZE = "ACCOUNT_UPDATE_ALERT_SNOOZE";
export const ACCOUNT_UPDATE_COMPLETE = "ACCOUNT_UPDATE_COMPLETE";
export const ACCOUNT_SUCCESS_ALERT_SNOOZE = "ACCOUNT_SUCCESS_ALERT_SNOOZE";
export const LOBBY_MAP_PICK = "LOBBY_MAP_PICK";
export const LOBBY_MAPS_UPDATE_BULK = "LOBBY_MAPS_UPDATE_BULK";
export const LOBBY_MAPS_TOGGLE_ALL = "LOBBY_MAPS_TOGGLE_ALL";
export const LOBBY_LEADER_MAP_TOGGLED = "LOBBY_LEADER_MAP_TOGGLED"; 
export const LOBBY_LEADER_MAPS_TOGGLE_ALL = "LOBBY_LEADER_MAPS_TOGGLE_ALL";
export const LOBBY_LEADER_UPDATED_MAPS = "LOBBY_LEADER_UPDATED_MAPS";
export const LOBBY_QUEUE_MODE_SWITCHED = "LOBBY_QUEUE_MODE_SWITCHED";
export const LOBBY_QUEUE_MODE_UPDATED = "LOBBY_QUEUE_MODE_UPDATED";
export const LOBBY_SERVER_LOCATION_TOGGLED = "LOBBY_SERVER_LOCATION_TOGGLED";
export const LOBBY_LEADER_SERVER_LOCATION_TOGGLED = "LOBBY_LEADER_SERVER_LOCATION_TOGGLED";
export const LOBBY_LEADER_UPDATED_SERVER_LOCATIONS = "LOBBY_LEADER_UPDATED_SERVER_LOCATIONS";
export const LOBBY_MATCHMAKING_OPTION_CHANGED = "LOBBY_MATCHMAKING_OPTION_CHANGED"; 
export const LOBBY_LEADER_MATCHMAKING_OPTION_CHANGED = "LOBBY_LEADER_MATCHMAKING_OPTION_CHANGED";
export const LOBBY_LEADER_UPDATED_OPTIONS = "LOBBY_LEADER_UPDATED_OPTIONS"; 

export const LOBBY_PLAYER_SEARCHING_FOR_MATCH_START =
  "LOBBY_PLAYER_SEARCHING_FOR_MATCH_START";
export const LOBBY_PLAYER_STOP_SEARCH = "LOBBY_PLAYER_STOP_SEARCH";
export const LOBBY_MATCH_FOUND_NOTIFY = "LOBBY_MATCH_FOUND_NOTIFY";
export const GET_MATCH_DATA = "GET_MATCH_DATA";
export const GET_SCOREBOARD_DATA = "GET_SCOREBOARD_DATA";
export const LOBBY_ACCEPT_MATCH = "LOBBY_ACCEPT_MATCH";
export const UPDATE_MATCH_ACCEPTANCE_STATUS = "UPDATE_MATCH_ACCEPTANCE_STATUS";
export const MATCH_ACCEPTANCE_CANCELLED = "MATCH_ACCEPTANCE_CANCELLED";
export const START_MAP_VOTE = "START_MAP_VOTE";
export const UPDATE_MAP_VOTE = "UPDATE_MAP_VOTE";
export const CAST_MAP_VOTE_LOCALLY = "CAST_MAP_VOTE_LOCALLY";
export const RESOLVE_MAP_VOTE = "RESOLVE_MAP_VOTE";
export const CLOSE_MAP_VOTE = "CLOSE_MAP_VOTE";

export const LOBBY_SEND_FRIEND_REQUEST_ERROR = "LOBBY_SEND_FRIEND_REQUEST_ERROR";
export const LOBBY_SEND_FRIEND_REQUEST_SUCCESS = "LOBBY_SEND_FRIEND_REQUEST_SUCCESS";
export const LOBBY_CLEAR_FRIEND_REQUEST_MESSAGES = "LOBBY_CLEAR_FRIEND_REQUEST_MESSAGES"; 
export const LOBBY_GET_FRIEND_REQUESTS = "LOBBY_GET_FRIEND_REQUESTS";
export const GET_PROFILE_RELATIONSHIP = "GET_PROFILE_RELATIONSHIP";
export const LOBBY_ACCEPT_FRIEND_REQUEST = "LOBBY_ACCEPT_FRIEND_REQUEST";
export const LOBBY_DECLINE_FRIEND_REQUEST = "LOBBY_DECLINE_FRIEND_REQUEST";
export const LOBBY_CANCEL_FRIEND_REQUEST = "LOBBY_CANCEL_FRIEND_REQUEST";
export const LOBBY_GET_FRIENDS = "LOBBY_GET_FRIENDS";
export const LOBBY_GET_PENDING_REQUESTS = "LOBBY_GET_PENDING_REQUESTS";
export const ADD_PENDING_REQUEST_LOCALLY = "ADD_PENDING_REQUEST_LOCALLY";
export const REMOVE_PENDING_REQUEST_LOCALLY = "REMOVE_PENDING_REQUEST_LOCALLY";
export const ADD_FRIEND_REQUEST_LOCALLY = "ADD_FRIEND_REQUEST_LOCALLY";
export const REMOVE_FRIEND_LOCALLY = "REMOVE_FRIEND_LOCALLY";
export const LOBBY_UPDATE_FRIEND_STATUS = "LOBBY_UPDATE_FRIEND_STATUS";
export const LOBBY_UPDATE_MEMBER_STATUS = "LOBBY_UPDATE_MEMBER_STATUS";
export const LOBBY_DELETE_FRIEND = "LOBBY_DELETE_FRIEND";
export const LOBBY_SEARCH_USERS_LOADING = "LOBBY_SEARCH_USERS_LOADING";
export const LOBBY_SEARCH_USERS_RESULTS = "LOBBY_SEARCH_USERS_RESULTS";
export const LOBBY_CLEAR_SEARCH_USERS = "LOBBY_CLEAR_SEARCH_USERS";
export const GLOBAL_PLAYER_SEARCH_LOADING = "GLOBAL_PLAYER_SEARCH_LOADING";
export const GLOBAL_PLAYER_SEARCH_RESULTS = "GLOBAL_PLAYER_SEARCH_RESULTS";
export const GLOBAL_PLAYER_SEARCH_CLEAR = "GLOBAL_PLAYER_SEARCH_CLEAR";

export const LOBBY_OPEN_CONFIRM_DIALOG = "LOBBY_OPEN_CONFIRM_DIALOG";
export const LOBBY_CLOSE_CONFIRM_DIALOG = "LOBBY_CLOSE_CONFIRM_DIALOG";
export const LOBBY_OPEN_JOIN_LOBBY_DIALOG = "LOBBY_OPEN_JOIN_LOBBY_DIALOG";
export const LOBBY_CLOSE_JOIN_LOBBY_DIALOG = "LOBBY_CLOSE_JOIN_LOBBY_DIALOG";
export const LOBBY_FRIEND_REQUEST_ACCEPTED = "LOBBY_FRIEND_REQUEST_ACCEPTED";
export const LOBBY_INVITE_START = "LOBBY_INVITE_START";
export const LOBBY_INVITE_SENT = "LOBBY_INVITE_SENT";
export const LOBBY_INVITE_EXPIRED = "LOBBY_INVITE_EXPIRED";
export const LOBBY_INVITE_DECLINED = "LOBBY_INVITE_DECLINED";
export const LOBBY_INVITE_ACCEPTED = "LOBBY_INVITE_ACCEPTED";
export const LOBBY_INVITE_CANCELLED = "LOBBY_INVITE_CANCELLED";
export const LOBBY_CLEAR_INVITE_ERROR = "LOBBY_CLEAR_INVITE_ERROR";
export const LOBBY_FRIEND_SIDEBAR_SET_OPEN = "LOBBY_FRIEND_SIDEBAR_SET_OPEN";
export const LOBBY_FRIEND_SIDEBAR_SET_TAB = "LOBBY_FRIEND_SIDEBAR_SET_TAB";
export const LOBBY_SETTINGS_MENU_SET_OPEN = "LOBBY_SETTINGS_MENU_SET_OPEN";
export const GET_PROFILE_PAGE_USER_DATA = "GET_PROFILE_PAGE_USER_DATA";
export const SET_PROFILE_DATA_LOADING = "SET_PROFILE_DATA_LOADING";
export const LOBBY_CREATE_NEW_LOBBY = "LOBBY_CREATE_NEW_LOBBY";
export const LOBBY_UPDATE_ADDED_NEW_PLAYER = "LOBBY_UPDATE_ADDED_NEW_PLAYER";
export const LOBBY_GET_LOBBY_BY_USER_ID = "LOBBY_GET_LOBBY_BY_USER_ID";
export const LOBBY_SHOW_PLAYER_JOINED_NOTIFICATION = "LOBBY_SHOW_PLAYER_JOINED_NOTIFICATION";
export const LOBBY_HIDE_PLAYER_JOINED_NOTIFICATION = "LOBBY_HIDE_PLAYER_JOINED_NOTIFICATION";
export const LOBBY_PLAYER_LEFT = "LOBBY_PLAYER_LEFT";
export const LOBBY_LEAVE_LOBBY = "LOBBY_LEAVE_LOBBY";
export const LOBBY_KICK_PLAYER_FROM_LOBBY = "LOBBY_KICK_PLAYER_FROM_LOBBY";
export const LOBBY_NOTIFY_PLAYER_HAS_BEEN_KICKED = "LOBBY_NOTIFY_PLAYER_HAS_BEEN_KICKED";
export const LOBBY_HIDE_PLAYER_KICKED_NOTIFICATION = "LOBBY_HIDE_PLAYER_KICKED_NOTIFICATION";
export const LOBBY_SHOW_PLAYER_LEFT_NOTIFICATION = "LOBBY_SHOW_PLAYER_LEFT_NOTIFICATION";
export const LOBBY_HIDE_PLAYER_LEFT_NOTIFICATION = "LOBBY_HIDE_PLAYER_LEFT_NOTIFICATION";
export const SORT_OPTION_MATCH_TABLE = "SORT_OPTION_MATCH_TABLE";
export const SHOW_UNVAILABLE_ACTION_MESSAGE = "SHOW_UNVAILABLE_ACTION_MESSAGE";
export const HIDE_UNVAILABLE_ACTION_MESSAGE = "HIDE_UNVAILABLE_ACTION_MESSAGE";
export const SHOW_QUEUE_ERROR_MESSAGE = "SHOW_QUEUE_ERROR_MESSAGE";
export const HIDE_QUEUE_ERROR_MESSAGE = "HIDE_QUEUE_ERROR_MESSAGE";
export const SHOW_QUEUE_BLOCKED_MODAL = "SHOW_QUEUE_BLOCKED_MODAL";
export const HIDE_QUEUE_BLOCKED_MODAL = "HIDE_QUEUE_BLOCKED_MODAL";
export const NOTIFY_MATCHMAKING_STARTED = "NOTIFY_MATCHMAKING_STARTED";
export const RESET_MATCHMAKING_STARTED = "RESET_MATCHMAKING_STARTED";
export const LOBBY_CODE_NOT_FOUND = "LOBBY_CODE_NOT_FOUND";
export const LOBBY_FULL = "LOBBY_FULL";
export const REPORT_PLAYER_UPDATE = "REPORT_PLAYER_UPDATE";
export const REPORT_PLAYER_SUBMIT_SUCCESS = "REPORT_PLAYER_SUBMIT_SUCCESS";
export const REPORT_PLAYER_CLEAR = "REPORT_PLAYER_CLEAR";
export const CLOSE_MATCH_ACCEPT_DIALOG = "CLOSE_MATCH_ACCEPT_DIALOG";
export const CLEAR_MATCH_DATA = "CLEAR_MATCH_DATA";
export const UPDATE_QUEUE_STATUS = "UPDATE_QUEUE_STATUS";
export const CLEAR_QUEUE_STATUS = "CLEAR_QUEUE_STATUS";
export const SET_PLATFORM_STATS = "SET_PLATFORM_STATS";
export const LOBBY_EXPAND_SEARCH = "LOBBY_EXPAND_SEARCH";
export const LOBBY_SMALLER_MATCH_STATUS = "LOBBY_SMALLER_MATCH_STATUS";

export const LEADERBOARD_LOAD_START = "LEADERBOARD_LOAD_START";
export const LEADERBOARD_LOAD_SUCCESS = "LEADERBOARD_LOAD_SUCCESS";
export const LEADERBOARD_LOAD_ERROR = "LEADERBOARD_LOAD_ERROR";

export const SET_MEMBERSHIP_STATUS = "SET_MEMBERSHIP_STATUS";
export const SET_SELECTED_SERVER_LOCATIONS = "SET_SELECTED_SERVER_LOCATIONS";
export const SET_SERVER_LOCATIONS = "SET_SERVER_LOCATIONS";

export const CS_SKILLS_LOADED = "CS_SKILLS_LOADED";
export const CS_SKILLS_SAVED = "CS_SKILLS_SAVED";
export const CS_SKILLS_TEMPLATE_LOADED = "CS_SKILLS_TEMPLATE_LOADED";

export const LATEST_MATCHES_LOAD_START = "LATEST_MATCHES_LOAD_START";
export const LATEST_MATCHES_LOAD_SUCCESS = "LATEST_MATCHES_LOAD_SUCCESS";
export const LATEST_MATCHES_LOAD_ERROR = "LATEST_MATCHES_LOAD_ERROR";
